import React from 'react';
import ReactMarkdown from 'react-markdown';
import {Container, Typography, Paper, Box} from '@mui/material';
import UserDanceTable from "../users_list/UserDanceTable";

const PdContent = `
# ПОЛОЖЕНИЕ  
## о порядке обработки, хранения и защиты персональных данных  
### в РОО "Рок-н-ролл Джокер"

---

### 1. Общие положения   

1.1. Настоящее Положение определяет порядок сбора, хранения, использования, передачи и защиты персональных данных (далее — ПДн), обрабатываемых РОО "Рок-н-ролл Джокер" (далее — Организатор, он же Оператор персональных данных) при организации и проведении танцевальных соревнований, а также при ином взаимодействии с участниками мероприятий.  

1.2. **Нормативные основания**:  
- Конституция РФ  
- Федеральный закон № 152-ФЗ «О персональных данных»  
- Федеральный закон № 149-ФЗ «Об информации, информационных технологиях и о защите информации»  
- Постановление Правительства РФ № 687 от 15.09.2008 г.  
- Постановление Правительства РФ № 1119 от 01.11.2012 г.  
- Иные нормативные акты РФ  

1.3. **Цели обработки**:  
- Регистрация и идентификация участников  
- Организация и проведение мероприятий  
- Информирование участников о мероприятиях и результатах  
- Выполнение требований законодательства РФ  

1.4. Использование сайта Организатора, а также подача заявок через электронные формы или приложения, означает согласие субъекта ПДн с условиями настоящего Положения.  

1.5. Организатор вправе вносить изменения в настоящее Положение. Обновлённая версия размещается на официальном сайте Организатора.  

---

### 2. Основные понятия  

- **Персональные данные (ПДн)** — любая информация, относящаяся к прямо или косвенно определенному физическому лицу: ФИО, дата рождения, контакты, спортивная категория, медицинские допуски, изображения (фото, видео), голос  
- **Обработка ПДн** — любые действия с ПДн: сбор, хранение, изменение, использование, передача, удаление  
- **Субъект ПДн** — физическое лицо (участник соревнований или его законный представитель)  

---

### 3. Принципы обработки ПДн  

3.1. Обработка ПДн осуществляется на основе следующих принципов:  
- Законности и справедливости  
- Ограничения обработки достижением конкретных, заранее заявленных целей  
- Соответствия объема и характера данных заявленным целям  
- Достоверности и актуальности  
- Ограниченности срока хранения  

3.2. Обработка допускается только при наличии согласия субъекта, за исключением случаев, предусмотренных законом.  

---

### 4. Сбор, хранение и защита ПДн  

4.1. **Источники получения**:  
- Непосредственное предоставление субъектом через анкеты, формы, приложения  
- Передача от третьих лиц (например, тренеров) при наличии согласия  

4.2. **Меры защиты**:  
- Шифрование и защита паролем  
- Контроль доступа  
- Назначение ответственного за защиту ПДн  
- Инструктаж и проверки сотрудников  

4.3. **Срок хранения**:  
- ПДн хранятся до достижения целей обработки или истечения срока, установленного законом  

---

### 5. Права субъектов ПДн  

5.1. Субъект ПДн имеет право:  
- Получать информацию об обработке своих ПДн  
- Требовать исправления, блокировки или удаления ПДн  
- Отозвать своё согласие на обработку  

5.2. **Порядок обращения**:  
- Запрос направляется письменно по почте или на email Организатора  
- Ответ предоставляется в течение 30 календарных дней  

---

### 6. Ответственность  

6.1. Лица, нарушившие настоящее Положение, несут ответственность в соответствии с:  
- Ст. 13.11 КоАП РФ  
- Ст. 137 УК РФ  
- Иными действующими нормативными актами  

---

> Актуальная версия настоящего Положения размещена на официальном сайте Организатора: [https://competition.rockandroll.ru/pd](/pd)

`;

const Pd = () => {
    return (
        <Box  sx={{
            overflow: 'auto',
            width: '100%',
            mt: 0,
            p: 5,
            background: '#80808040',
            height: (window.innerHeight - 50) + 'px'
        }}>
            <ReactMarkdown>
                {PdContent}
            </ReactMarkdown>
        </Box>
    );
};

export default Pd;